import { PieceColor } from "../../../enums/PieceColor";
import { TriangleRotationStatus } from "../../../enums/TriangleRotationStatus";
import { ITriangleModel } from "../ITriangleModel";

export class TriangleModel implements ITriangleModel{
    private readonly color: PieceColor;
    private readonly triangleRotationStatus: TriangleRotationStatus;

    public constructor(
        rotationStatus: TriangleRotationStatus,
        color: PieceColor
    ) {
        this.triangleRotationStatus = rotationStatus;
        this.color = color;
    }

    public get Color(): PieceColor {
        return this.color;
    }

    public get TriangleRotationStatus(): TriangleRotationStatus {
        return this.triangleRotationStatus;
    }
}